// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__sUYx6","title":"menu_title__+BiK3","subTitle":"menu_subTitle__gKYgv","row":"menu_row__+Hk4U","item":"menu_item__VhxEY"};